import useSWR from "swr";
import { authApi } from "@/lib/api";
import { useAuth } from "@/features/auth/context/auth-context";

export type Company = {
  id: string;
  name: string;
  subscriptionId: string;
  active?: boolean;
};

/**
 * Hook reutilizable para obtener las sociedades del usuario autenticado.
 * El backend filtra por x-subscription-id automáticamente.
 */
export function useUserCompanies(subscriptionId?: string) {
  const { token, isSystemMode } = useAuth();

  const canFetch = token && !isSystemMode;

  const swrKey = canFetch ? ["/auth/companies", subscriptionId || ""] : null;

  const { data, error, isLoading, mutate } = useSWR<Company[]>(
    swrKey,
    () => authApi.companies(),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60000
    }
  );

  return {
    companies: data || [],
    allCompanies: data || [],
    isLoading,
    isError: error,
    mutate
  };
}
